import React, { Component } from 'react';
import { connect } from "react-redux";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { ComponentHeader, InformationModal, VerifiedModal } from '../common';
import { getAllSsoApi, getAllRoleApi } from './Api';
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import { Button, Col, Image, Row } from "react-bootstrap";
import { API_LIMIT, MODULE_ID_MAP, START_PAGE, isModuleExist } from "../../utils/Constant";
import editPencil from "../../assets/images/edit-icon.png";
import { CHILD_ROLE_VERIFY, SSO_VERIFY } from '../../utils/urls';
import FilterVefiedDropDown from '../common/FilterVefiedDropDown';
import { deleteAuthCommonApi } from "../content/Api";
import { toast } from 'react-toastify';
import { withRouter } from '../../utils/hoc/withRouter';
import { Tag } from 'antd';
import OptionsDropdown from '../../utils/commonComponent/OptionsDropdown';
import moment from 'moment';


class SubloginRole extends Component {
    constructor(props) {
        super(props);
        const AccesData = isModuleExist(MODULE_ID_MAP.RoleChildRole);

        this.state = {
            access: AccesData,
            delete: false,
            deleteData: {},
            editData: "",
            showEdit: false,
            isVerify: false,
            show: false,
            verified: '',
            verifyUrl: ''
        }
    }

    componentDidMount() {
        const { history } = this.props;
        history({
            pathname: this.props.location.pathname,
            search: `?p=${this.state.currentPage || START_PAGE}`,
        });
        this.props.getAllRoleApi(this);
    }
    componentDidUpdate(prevProps, prevState) {
        const prevParams = new URLSearchParams(prevProps.location.search);
        const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
        const prevVerified = prevParams.get("isVerified") || "";
        const prevSize = parseInt(prevParams.get("pageSize"), 10) || API_LIMIT;

        const params = new URLSearchParams(this.props.location.search);
        const page = parseInt(params.get("page"), 10) || START_PAGE;
        const verified = params.get("isVerified") || "";
        const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;

        // const search = params.get("search") || "";

        if (prevPage !== page || prevVerified !== verified || prevParams.get("search") !== params.get("search") || prevSize !== size) {
            this.setState({ currentPage: page }, () => {
                this.props.getAllRoleApi(this);

            });
        }
    }
    showEditModal = (rowData = null) => {
        this.props.history({ pathname: `/child-role/form`, state: { "editData": rowData } })
        this.setState({
            showEdit: !this.state.showEdit,
            editData: rowData
        });
    };
    openCloseDeleteModal = (rowData) => {
        this.setState({
            delete: !this.state.delete,
            deleteData: rowData,
        });
    };
    deleteHandle = async (id) => {
        const res = await deleteAuthCommonApi(`/childRole/${id}`);
        // console.log(res)
        if (res?.status === 200) {
            this.props.getAllRoleApi(this);
            this.setState({
                delete: !this.state.delete
            });

        } else {
            toast.error("Somthis wrong...")
        }
    }

    editRole = (data) => {
        let state = {}
        let path = `/edit-role/${data?.id}`

        state = { "uuid": data?.uuid }
        this.props.history.push({ pathname: path, state: state });
    }
    render() {
        const { access } = this.state;
        const { roleList, totalPages, currentPage } = this.props.subloginState;
        // console.log('roleList', roleList);
        return (
            <>

                {this.state.delete && (
                    <InformationModal
                        show={this.state.delete}
                        id={this.state.deleteData?.uuid}
                        title={`Are you sure you want to delete ${this.state.deleteData?.roleName} ?`}
                        handleClose={this.openCloseDeleteModal}
                        handleDelete={this.deleteHandle}
                    />
                )}
                <VerifiedModal
                    // name={`this '${this.state.editData?.campaignName}' campaign.`}
                    name={`'${this.state.editData?.childRoleName}' role`}
                    show={this.state.show}
                    url={CHILD_ROLE_VERIFY + `/${this.state?.editData?.uuid}`}
                    isVerified={this.state.isVerify}
                    handleCancel={() => { this.setState({ show: false }) }}
                    successRes={() => { this.props.getAllRoleApi(this) }}
                />
                <section className="request-section">
                    <ComponentHeader
                        title="Child Roles"
                        breadcrumb={[["Child Roles", "/child-role"]]}
                        primaryBtn={access.createAccess ? "Add Child Role" : ""}
                        handlePrimaryBtn={() => {
                            this.props.history({ pathname: "/child-role/form", state: { roleList } });
                        }}
                        ctx={this}
                    />
                    <Row>
                        <Col sm={2}>
                            <FilterVefiedDropDown ctx={this} />
                        </Col>
                    </Row>
                    <div className="commom-table-wrapper">
                        <CustomTable
                            ctx={this}
                            data={roleList?.list || []}
                            columns={[
                                {
                                    width: 180,
                                    title: "Role Name",
                                    dataIndex: "roleName",
                                    className: "name",
                                    render: (text, rowData, dataKey) => {
                                        return rowData?.childRoleName || 'Na';
                                    },
                                },
                                {
                                    width: access.verificationAccess ? 110 : 0,
                                    title: "Verified",
                                    dataIndex: "isVerified",
                                    className: "verify",
                                    isCell: true,
                                    render: (text, rowData, dataKey) => {
                                        const color = rowData.isVerified ? 'green' : 'orange';
                                        return <div className=" d-flex align-items-center inter-medium">
                                            <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                                                <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                                            </Tag>
                                        </div>;
                                    },
                                },
                                {
                                    width: 180,
                                    title: "Created At",
                                    dataIndex: "roleName",
                                    className: "name",
                                    render: (text, rowData, dataKey) => {
                                        return moment(rowData?.createdAt).format("lll") || 'Na';
                                    },
                                },
                                {
                                    width: 180,
                                    title: "Updated At",
                                    dataIndex: "roleName",
                                    className: "name",
                                    render: (text, rowData, dataKey) => {
                                        if (!rowData.updatedAt) return null
                                        return moment(rowData?.updatedAt).format("lll");
                                    },
                                },
                                {
                                    width: 20,
                                    title: "Action",
                                    dataIndex: "",
                                    fixed: "right",
                                    className: "",
                                    isCell: true,
                                    render: (text, rowData, dataKey) => {
                                        return (


                                            <>
                                                <OptionsDropdown
                                                    editHandler={access.updateAccess ? () => { this.showEditModal(rowData) } : null}
                                                    deleteHandler={access.deleteAccess ? () => { this.openCloseDeleteModal(rowData) } : null}
                                                />
                                            </>

                                        );
                                    },
                                },
                            ]}

                            total={roleList?.length || 0}
                            loading={this.state.isLoading}
                        />
                    </div>
                </section>
            </>
        )
    }
}

const mapStateToProps = state => ({
    subloginState: state.SubloginState
});
const mapDispatchToProps = {
    getAllRoleApi,
}
SubloginRole.propTypes = {
    // getPosts: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SubloginRole));